// src/components/ErrorFallback.tsx

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import React from 'react';
import Typography from '@mui/material/Typography';
import { clearError } from '../../redux/slices/errorSlice';
import { useDispatch } from 'react-redux';

export interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  const dispatch = useDispatch();

  return (
    <Modal
      open={true}
      onClose={resetErrorBoundary}
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-description"
    >
      <Box sx={style}>
        <Typography id="error-modal-title" variant="h6" component="h2">
          Something went wrong
        </Typography>
        <Typography id="error-modal-description" sx={{ mt: 2, color: 'red' }}>
          {error.message}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            resetErrorBoundary();
            dispatch(clearError());
          }}
          sx={{ mt: 2 }}
        >
          Try Again
        </Button>
      </Box>
    </Modal>
  );
};

export default ErrorFallback;
